import styled from "styled-components"
import { ContainerWithColor } from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/ContainerWithColor/ContainerWithColor"

export const Container = styled(ContainerWithColor)`
    /* Match POC design specifications */
    background-color: white;
    border-radius: 16px;
    border: 1px solid #e9ecef;
    box-shadow: 0px 2px 12px -4px rgba(0, 0, 0, 0.12);

    /* Flex layout for content */
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;

    /* Width and centering (match POC unit semantics using rem) */
    width: 100%;
    max-width: 45rem; /* 45rem = 720px at 16px root */
    margin: 0 auto;

    /* Padding - 2rem desktop, 1.5rem mobile (POC unit semantics) */
    padding: 2rem;

    @media (max-width: 768px) {
        padding: 1.5rem;
    }
`
